module.exports = __webpack_public_path__ + "img/6.57d527e2.png";